import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import {
  customDateFormat,
  formatDate,
  formatDateForInput,
} from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.relativeFormRequest;
const queryKey = "relativeFormRequest";

async function fetchRelativeFormRequest(
  currentPage,
  search,
  saleBlockId,
  saleAreaId,
  branchId
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (saleBlockId) options.saleBlockId = saleBlockId;
    if (saleAreaId) options.saleAreaId = saleAreaId;
    if (branchId) options.branchId = branchId;

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/relativeRegisterForm/?${queryParams}`);
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries
    );

    const newData = data?.items.map((item, index) => {
      return {
        id: item?._id || "",
        status: item?.status || "-",
        creatorName: item?.creatorObject?.fullName || "-",
        code: item?.relativeInfo?.code || "-",
        fullName: item?.relativeInfo?.fullName || "-",
        contact: [item?.relativeInfo?.email, item?.relativeInfo?.phone],
        identificationNumber: item?.relativeInfo?.identificationNumber || "-",
        dateOfIdentification: item?.relativeInfo?.dateOfIdentification
          ? formatDate(
              formatDateForInput(item?.relativeInfo?.dateOfIdentification)
            )
          : "-",
        placeOfIdentification: item?.relativeInfo?.placeOfIdentification || "-",
        permanentAddress: item?.relativeInfo?.permanentAddress || "-",
        currentAddress: item?.relativeInfo?.currentAddress || "-",
        startTime: item?.relativeInfo?.startTime
          ? formatDate(formatDateForInput(item?.relativeInfo?.startTime))
          : "-",
        // dateOfBirth: item?.relativeInfo?.dateOfBirth
        //   ? formatDate(formatDateForInput(item?.relativeInfo?.dateOfBirth))
        //   : "-",
        taxCode: item?.relativeInfo?.taxCode || "-",
        detail: {
          status: item?.status || "-",
          creatorName: item?.creatorObject?.fullName || "-",
          creatorCode: item?.creatorObject?.code || "-",
          code: item?.relativeInfo?.code || "-",
          fullName: item?.relativeInfo?.fullName || "-",
          phone: item?.relativeInfo?.phone || "-",
          email: item?.relativeInfo?.email || "-",
          startTime: item?.relativeInfo?.startTime
            ? formatDate(formatDateForInput(item?.relativeInfo?.startTime))
            : "-",
        },
        edit: {
          ...(item?._id && { id: item._id }),
          ...(item?.relativeInfo?.fullName && {
            fullName: item?.relativeInfo?.fullName,
          }),
          ...(item?.relativeInfo?.phone && {
            phone: item?.relativeInfo?.phone,
          }),
          ...(item?.relativeInfo?.email && {
            email: item?.relativeInfo?.email,
          }),
          ...(item?.relativeInfo?.identificationNumber && {
            identificationNumber: item?.relativeInfo?.identificationNumber,
          }),
          ...(item?.relativeInfo?.dateOfIdentification && {
            dateOfIdentification: item?.relativeInfo?.dateOfIdentification,
          }),
          ...(item?.relativeInfo?.placeOfIdentification && {
            placeOfIdentification: item?.relativeInfo?.placeOfIdentification,
          }),
          ...(item?.relativeInfo?.permanentAddress && {
            permanentAddress: item?.relativeInfo?.permanentAddress,
          }),
          ...(item?.relativeInfo?.currentAddress && {
            currentAddress: item?.relativeInfo?.currentAddress,
          }),
          ...(item?.relativeInfo?.startTime && {
            startTime: item?.relativeInfo?.startTime,
          }),
          ...(item?.relativeInfo?.dateOfBirth && {
            dateOfBirth: item?.relativeInfo?.dateOfBirth,
          }),
          ...(item?.relativeInfo?.gender !== "" &&
            item?.relativeInfo?.gender !== null && {
              gender: item?.relativeInfo?.gender,
            }),
          ...(item?.relativeInfo?.taxCode && {
            taxCode: item?.relativeInfo?.taxCode,
          }),
        },
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching onLeave data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useRelativeFormRequest(
  search,
  saleBlockId,
  saleAreaId,
  branchId
) {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [
      queryKey,
      currentPage,
      search,
      saleBlockId,
      saleAreaId,
      branchId,
    ],
    queryFn: () =>
      fetchRelativeFormRequest(
        currentPage,
        search,
        saleBlockId,
        saleAreaId,
        branchId
      ),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error(
        "Error fetching update Business Category Request data:",
        error
      );
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    relativeFormRequest: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
